import { path } from "ramda";

export const selector = path(["clientProfileEntries", "data"]);

export const filtersSelector = path(["clientProfileEntries", "filters"]);

export const pageInfoSelector = path(["clientProfileEntries", "pageInfo"]);

export const clientProfileEntriesLoading = path([
  "clientProfileEntries",
  "isLoading",
]);

export const detailsSelector = path(["clientProfileEntries", "data"]);

export const reloadSelector = path(["clientProfileEntries", "reload"]);

export const noEntriesMessageClientProfileSelector = path([
  "clientProfileEntries",
  "noEntriesMessage",
]);

export const clientProfileEntryDetailsSelector = path([
  "clientProfileEntryDetails",
  "data",
]);

export const clientProfileEntryDetailsSelectorLoading = path([
  "clientProfileEntryDetails",
  "isLoading",
]);

export const changeClientProfileEntryStatusSelector = path([
  "changeClientProfileEntryStatus",
  "data",
]);

export const isStatusLoadingSelector = path([
  "changeClientProfileEntryStatus",
  "isLoading",
]);

export const clientProfilePdfExportSelector = path([
  "exportClientProfilePdf",
  "data",
]);

export const clientProfilePdfExportIsLoadingSelector = path([
  "exportClientProfilePdf",
  "isLoading",
]);



// WEBPACK FOOTER //
// ./src/features/client-profile/selectors/index.js